module.exports = __webpack_public_path__ + "img/Villa_Borna_20.fa611046.jpg";